// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"0540176e","856":"a6825c5a","952":"be57cb97"}[chunkId] + ".chunk.js";
};